'use strict';
const _ = require('underscore');
const Backbone = require('backbone');

var States = {
    synced: 'synced',
    unsync: 'unsync',
    syncing: 'syncing',
    conflict: 'conflict'
};

var model = {
    /**
     * Model の Sync 状態を保持する Model
     */
    defaults: {
        state: States.synced
    },

    setState: function(state) {
        if(!(state in States)) {
            throw `${state} not in sync state.`;
        }

        this.set({state: state});
        this.trigger(state);
    }
};

_.each(States, function(v, k) {
    var camelKey = k.charAt(0).toUpperCase() + k.slice(1);
    var is = 'is' + camelKey;
    model[is] = function() {
        return this.get('state') == v;
    };

    var set = 'set' + camelKey;
    model[set] = function() {
        this.setState(k);
    };
});

module.exports = Backbone.Model.extend(model, {
    States: States
});



// WEBPACK FOOTER //
// ./system/domain/entity/sync-state.js